import React from 'react';
import { useI18n } from './i18n';
import { parseAromaTypes } from './codes';
import { layoutOf, normalizeVariant } from './onavVariants';

// Sections of the ONAV sheet detail view, for both variants (still / sparkling): variant and competition details, then the marks of each
// section with the totals out of the variant's maxima (see onavVariants.js). Marks that are null/missing are not listed.
function MarksGrid({ sheet, rows }) {
  const { t } = useI18n();
  return (
    <div className="detail-grid">
      {rows.filter((r) => sheet[r.key] !== null && sheet[r.key] !== undefined).map((r) => (
        <span key={r.key}>{t(`onav.p.${r.key}`)}: {sheet[r.key]}/{r.max}</span>
      ))}
    </div>
  );
}

function OnavDetailSections({ sheet }) {
  const { t, tc } = useI18n();
  const variant = normalizeVariant(sheet.variant);
  const layout = layoutOf(variant);
  const competition = [['event', sheet.event], ['commission_number', sheet.commission_number], ['sample_number', sheet.sample_number],
    ['presentation_category', sheet.presentation_category], ['tasting_time', sheet.tasting_time]].filter(([, value]) => value);
  return (
    <>
      <p><strong>{t('onav.variant.title')}:</strong> {t(`onav.variant.${variant}`)}
        {sheet.wine_color ? <> | <strong>{t('onav.f.wine_color')}:</strong> {tc('wine_type', sheet.wine_color)}</> : null}</p>
      {competition.length > 0 && (
        <p className="onav-competition-detail">
          {competition.map(([key, value], i) => (
            <span key={key}>{i > 0 ? ' | ' : ''}<strong>{t(`onav.f.${key}`)}:</strong> {value}</span>
          ))}
        </p>
      )}

      <h3>{t('app.d.sec_visual')} ({sheet.total_visual}/{layout.totals.visual})</h3>
      <MarksGrid sheet={sheet} rows={layout.visual} />

      <h3>{t('app.d.sec_olfactory')} ({sheet.total_olfactory}/{layout.totals.olfactory})</h3>
      <MarksGrid sheet={sheet} rows={layout.olfactory} />
      {sheet.aroma_types && (
        <p><strong>{t('app.d.aromas')}:</strong> {parseAromaTypes(sheet.aroma_types).map((c) => tc('aroma', c)).join(', ')}</p>
      )}

      <h3>{t('app.d.sec_gustatory')} ({sheet.total_gustatory}/{layout.totals.gustatory})</h3>
      <MarksGrid sheet={sheet} rows={layout.gustatory} />

      <h3>{t('app.d.sec_final')} ({sheet.total_final}/{layout.totals.final})</h3>
      <MarksGrid sheet={sheet} rows={layout.final} />
    </>
  );
}

export default OnavDetailSections;
